import * as React from 'react';
import { Button, Dimmer, Header, Icon, Label, Ref, Segment, Modal as UIModal } from 'semantic-ui-react';
import { Comparison } from '~/Api/Report';
import { ErrorAlert } from '~/UI';
import * as ReportApi from '~/Api/Report';
import { useApi } from '~/ApiHooks';
import { useStore } from '~/Application/Store';
import { MessageType, useFlashMessage } from '~/FlashMessage';
import { toUserFormat } from '~/Report/DecimalFormatter';
import { SaveReportModal } from '~/SaveReportModal';
import { Failure } from '~/Result';
import { ReportsRoute } from '~/Application/routes';
var ButtonState;
(function (ButtonState) {
    ButtonState["more"] = "v\u00EDce";
    ButtonState["less"] = "m\u00E9n\u011B";
})(ButtonState || (ButtonState = {}));
var APPLY_CHANGES_BUTTON_TEXT = 'Aplikovat změny na report';
var ReportDeleteConfirmModal = function (_a) {
    var report = _a.report, onClose = _a.onClose;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useFlashMessage(), setFlashMessage = _c[1];
    var reloadCustomReports = useStore().reloadCustomReports;
    var redirect = ReportsRoute.useRedirect();
    var deleteReport = useApi()[0];
    var handleDeleteRequest = function (event) {
        event.preventDefault();
        deleteReport(new ReportApi.DeleteRequest(report.id)).then(function (result) {
            setLoading(true);
            if (result instanceof Failure) {
                result.mapError(function (error) {
                    error.codes.forEach(function (code) {
                        setFlashMessage({
                            subtext: code,
                            text: 'Chyba při mazání reportu',
                            type: MessageType.error,
                        });
                    });
                });
                setLoading(false);
                onClose();
                return;
            }
            reloadCustomReports();
            redirect({});
            setLoading(false);
            onClose();
            setFlashMessage({
                text: 'Report smazán',
                type: MessageType.success,
            });
        });
    };
    return (<UIModal open onClose={onClose}>
			<UIModal.Content>
				<ErrorAlert>Upravdu chcete report "{report.name}" smazat?</ErrorAlert>
			</UIModal.Content>
			<UIModal.Actions>
				<Button disabled={loading} loading={loading} onClick={onClose}>
					Zrušit
				</Button>
				<Button data-testid='report-delete-confirm' disabled={loading} loading={loading} onClick={handleDeleteRequest}>
					Smazat
				</Button>
			</UIModal.Actions>
		</UIModal>);
};
export var ReportSettings = function (_a) {
    var everCustomized = _a.everCustomized, isLoading = _a.isLoading, savingCustomReport = _a.savingCustomReport, unusedChanges = _a.unusedChanges, updatedReport = _a.updatedReport, revealColumn = _a.revealColumn, removeFilter = _a.removeFilter, removeSort = _a.removeSort, customize = _a.customize, onSaveCustomReportChanges = _a.onSaveCustomReportChanges, onSaveReportEdits = _a.onSaveReportEdits;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState(false), moreHiddenColumns = _c[0], showMoreHidden = _c[1];
    var _d = React.useState(false), deleteModalVisibility = _d[0], setDeleteModalVisibility = _d[1];
    var _e = React.useState(false), moreFiltered = _e[0], showMoreFiltered = _e[1];
    var _f = React.useState(false), moreSorted = _f[0], showMoreSorted = _f[1];
    var refHiddenColumns = React.useRef(null);
    var refFiltered = React.useRef(null);
    var refSorted = React.useRef(null);
    var _g = React.useState(false), showHiddenColumnsButton = _g[0], setShowHiddenColumnsButton = _g[1];
    var _h = React.useState(false), showFilteredButton = _h[0], setShowFilteredButton = _h[1];
    var _j = React.useState(false), showSortedButton = _j[0], setShowSortedButton = _j[1];
    React.useEffect(function () {
        var _a, _b, _c;
        if (((_a = refHiddenColumns.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== undefined && refHiddenColumns.current.offsetHeight > 32) {
            setShowHiddenColumnsButton(true);
        }
        else {
            setShowHiddenColumnsButton(false);
        }
        if (((_b = refFiltered.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) !== undefined && refFiltered.current.offsetHeight > 32) {
            setShowFilteredButton(true);
        }
        else {
            setShowFilteredButton(false);
        }
        if (((_c = refSorted.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== undefined && refSorted.current.offsetHeight > 32) {
            setShowSortedButton(true);
        }
        else {
            setShowSortedButton(false);
        }
    }, [open, updatedReport]);
    return (<Dimmer.Dimmable dimmed={isLoading}>
			<Dimmer inverted active={isLoading}/>
			{open ? (<SaveReportModal report={updatedReport} onClose={function () {
                setOpen(false);
            }}/>) : null}
			<Segment.Group className='report-settings' data-testid='report-settings'>
				<Segment className={!moreHiddenColumns ? 'closed-report-settings' : ''} data-testid='hidden' size='small'>
					<Ref innerRef={refHiddenColumns}>
						<div>
							<Header className='report-settings-header' size='small'>
								Skryté sloupce:
							</Header>
							{showHiddenColumnsButton ? (<Button className='show-more-btn' onClick={function () {
                showMoreHidden(!moreHiddenColumns);
            }}>
									{moreHiddenColumns ? ButtonState.less : ButtonState.more}
								</Button>) : null}
							{updatedReport.hiddenColumns.map(function (hidden, index) { return (<Label data-testid={hidden.id} key={index}>
									{hidden.title}
									<Icon name='delete' onClick={function () {
                onSaveReportEdits(revealColumn(updatedReport, hidden));
            }}/>
								</Label>); })}
						</div>
					</Ref>
				</Segment>
				<Segment className={!moreFiltered ? 'closed-report-settings' : ''} data-testid='filtered' size='small'>
					<Ref innerRef={refFiltered}>
						<div>
							<Header className='report-settings-header' size='small'>
								Vybrané hodnoty:
							</Header>
							{showFilteredButton ? (<Button className='show-more-btn' onClick={function () {
                showMoreFiltered(!moreFiltered);
            }}>
									{moreFiltered ? ButtonState.less : ButtonState.more}
								</Button>) : null}
							{updatedReport.columnFilters.length === 0 ? (<Label>
									Všechny
									<Icon name='delete'/>
								</Label>) : null}
							{updatedReport.columnFilters.map(function (filter, index) {
            var _a, _b;
            return (<Label className={filter.comparison === Comparison.notEqual ? 'grey' : ''} data-testid={filter.value} key={index}>
									{(_b = (_a = updatedReport.headers.find(function (column) { return column.id === filter.columnName; })) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : ''}:
									{toUserFormat(filter.dataType, filter.value)}
									<Icon name='delete' onClick={function () {
                    onSaveReportEdits(removeFilter(updatedReport, filter));
                }}/>
								</Label>);
        })}
						</div>
					</Ref>
				</Segment>
				<Segment className={!moreSorted ? 'closed-report-settings' : ''} data-testid='sorted' size='small'>
					<Ref innerRef={refSorted}>
						<div>
							<Header className='report-settings-header' size='small'>
								Seřazeno:
							</Header>
							{showSortedButton ? (<Button className='show-more-btn' onClick={function () {
                showMoreSorted(!moreSorted);
            }}>
									{moreSorted ? ButtonState.less : ButtonState.more}
								</Button>) : null}
							{updatedReport.sort.map(function (sort, index) {
            var _a, _b;
            return (<Label data-testid={"".concat(sort.property, "-").concat(sort.direction)} key={index}>
									{(_b = (_a = updatedReport.headers.find(function (head) { return sort.property === head.id; })) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : ''}
									<Icon name={sort.direction === 'asc' ? 'sort amount up' : 'sort amount down'}/>
									<Icon name='delete' onClick={function () {
                    onSaveReportEdits(removeSort(updatedReport, sort.property));
                }}/>
								</Label>);
        })}
						</div>
					</Ref>
				</Segment>
			</Segment.Group>
			{!updatedReport.isCustom && (<Button compact primary data-testid='save-report-settings' floated='right' onClick={function () {
                setOpen(!open);
            }}>
					Uložit
				</Button>)}
			{unusedChanges && (<span data-testid='apply-report-changes-hint'>
					Nastavení změněno. Pro zobrazení dat s tímto nastavením klikněte '{APPLY_CHANGES_BUTTON_TEXT}'
				</span>)}
			<Button compact primary data-testid='customize' disabled={!unusedChanges} floated='right' onClick={customize}>
				{APPLY_CHANGES_BUTTON_TEXT}
			</Button>
			{updatedReport.isDeletable() && (<Button compact primary data-testid='delete-report-button' floated='right' onClick={function () { return setDeleteModalVisibility(true); }}>
					Smazat
				</Button>)}
			<Button compact primary data-testid='save-custom-report-changes' disabled={!everCustomized && !unusedChanges} floated='right' loading={savingCustomReport} onClick={onSaveCustomReportChanges}>
				Uložit změny v reportu
			</Button>
			{deleteModalVisibility && (<ReportDeleteConfirmModal report={updatedReport} onClose={function () { return setDeleteModalVisibility(false); }}/>)}
		</Dimmer.Dimmable>);
};
ReportSettings.displayName = 'ReportSettings';
